import React from "react";
import LayoutPublicRoutes from "@/src/containers/Layouts/LayoutPublicRoutes";
import CookiePolicy from "@/src/components/CookiePolicy/CookiePolicy";
import Container from "@/src/components/Container/Container";
import CookiePolicyPageMeta from "./CookiePolicyPageMeta";

const CookiePolicyPage = () => {
  return (
    <LayoutPublicRoutes>
      <Container showVerticalPadding={false}>
        <CookiePolicyPageMeta />
        <CookiePolicy />
      </Container>
    </LayoutPublicRoutes>
  );
};
export default CookiePolicyPage;
